// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__38MbY","box":"WorkspacesBox_box__2zk0j","node":"WorkspacesBox_node__pDnr8"};